import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { QUERY_KEY } from "@/modules/questionarios/components/questionario-table/QuestionarioTable";
import { getQuestionarioItem } from "@/modules/questionarios/firestore";
import useUserStore from "@/modules/users/store";

type TGetQuestionarioResponse = Awaited<ReturnType<typeof getQuestionarioItem>>;

/**
 * Get ideia from url params
 * @param empresaId - Empresa id
 * @param questionarioId - Ideia id
 * @returns - Ideia or null if not found
 */
function useGetQuestionarioItem(empresaId: string, questionarioId: string) {
  const parameters = useParams<{ licenciadaId: string }>();
  const licenciadaId = useUserStore((state) => state.activeLicenciadaId) || parameters.licenciadaId;

  return useQuery<TGetQuestionarioResponse, FirestoreError, TQuestionario | null>({
    queryKey: [QUERY_KEY, questionarioId, empresaId, licenciadaId],
    queryFn() {
      if (!empresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!questionarioId) {
        throw new Error("Ideia não selecionada");
      }
      return getQuestionarioItem(empresaId, questionarioId, licenciadaId);
    },
    select(dataResponse) {
      if (!dataResponse.exists()) {
        return null;
      }

      return dataResponse.data();
    },
    enabled: !!questionarioId && !!empresaId && !!licenciadaId
  });
}

export default useGetQuestionarioItem;
